module.exports = __webpack_public_path__ + "static/media/kjeveortoped.508f346c.mp3";